// extracted by mini-css-extract-plugin
export default {"header":"modal-header_header__hp4FC","close":"modal-header_close__6OVKH"};